// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"DxtoGdLWa8Q0m-K90pghyg=="};